import React, {useEffect, useState} from 'react';
import {FaUser} from "react-icons/fa";
import { FaPowerOff } from "react-icons/fa";
import {useNavigate} from "react-router-dom";
import apiRequests from "../axios/config/config";


export default function Header() {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState();

    function logout () {

        localStorage.clear();
        navigate("/")
    }

    function getApi() {

        setLoading(true);
        apiRequests.get('/api/admin/v1/get-my-profile')
            .then(res => {
                const data = res.data.data;
               setUser(data);
            })
            .catch(err => {
            })
            .finally(() => setLoading(false));

    }

    useEffect(() => {
        getApi()
    }, []);


    return (

        <div className="flex items-center  md:w-full justify-center">

            <div
                className="flex items-center justify-between bg-secondColor-shade6 text-white rounded-xl py-3 px-5 my-2 w-[60%] md:w-11/12">

                <div className="flex gap-2  items-center">
                    <FaUser/>
                    {user?.firstName} {user?.lastName}
                </div>

                <div className="text-red-600 hover:cursor-pointer" onClick={logout}>
                    <FaPowerOff/>
                </div>


            </div>

        </div>
    )
}